import {css} from 'styled-components';
import logoMdl from './icons/mdl/logo-mdl.svg';
import progress1 from './icons/mdl/step-indicator-1.svg';
import progress2 from './icons/mdl/step-indicator-2.svg';
import progress3 from './icons/mdl/step-indicator-3.svg';
import progress1of2 from './icons/mdl/step-indicator-1of2.svg';
import progress2of2 from './icons/mdl/step-indicator-2of2.svg';
import whatsapp from './icons/sho/whatsapp.png';
import facebook from './icons/sho/facebook.svg';
import twitter from './icons/sho/x.svg';
import linkedin from './icons/sho/linkedin.svg';
import instagram from './icons/sho/instagram.svg';

// Palette taken from mdlfonds.nl
const purple = '#5F348A';
const purpleDark = '#432461';
const darkPurple = '#332561';
const lilac = '#F3EFFF';
const lilacDark = '#E7DFF5';
const borderColor = '#DFD6E8';
const inputBorderColor = '#857CA0';
const placeholderColor = '#AF99C5';
const errorColor = '#CF2E2E';

const bodyFont = 'Lato, "Open Sans", Arial, sans-serif';
const titleFont = 'Poppins, "Open Sans", Arial, sans-serif';

export default {
  // GlobalStyles
  bodyFontFamily: bodyFont,
  h1FontFamily: titleFont,
  h3FontFamily: titleFont,
  h1FontSize: '26px',
  h1FontColor: purple,
  bodyFontSize: '16px',
  bodyFontColor: darkPurple,
  linkHoverColor: purpleDark,
  background: css`
    background-image: ${props => `url('${props.backgroundImageUrl}')`};
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    background-color: ${lilac};
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    z-index: -10;
    background-size: cover;

    @media (min-width: 769px) and (max-width: 1024px) {
      background-image: ${props => `url('${props.backgroundImageTabletUrl}')`};
      background-position-y: top;
      background-position-x: left;
      background-attachment: local;
      left: -240px;
    }

    @media (max-width: 768px) {
      background-image: ${props => `url('${props.backgroundImageMobileUrl}')`};
      width: 100%;
      height: 100%;
      background-color: white;
      background-size: contain;
      background-position-y: top;
      background-position-x: center;
      background-repeat: no-repeat;
      inset: initial;
      z-index: -1;
      background-attachment: local;
      position: absolute;
    }
  `,
  // AmountButton
  amountButton: {
    color: purple,
    inactiveColor: darkPurple,
    fontFamily: bodyFont,
    fontSize: '18px',
    fontWeight: '700',
    width: 'calc(50% - 6.5px)',
    height: '56px',
    border: `1px solid ${borderColor}`,
    borderRadius: '28px',
    backgroundColor: '#fff',
    backgroundColorActive: lilac,
    borderHover: `1px solid ${purple}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${purple}`
  },
  frequencyButton: {
    color: purple,
    inactiveColor: darkPurple,
    fontFamily: bodyFont,
    fontSize: '18px',
    fontWeight: '700',
    width: 'calc(50% - 6.5px)',
    height: '56px',
    border: `1px solid ${borderColor}`,
    borderRadius: '28px',
    backgroundColor: '#fff',
    backgroundColorActive: lilac,
    borderHover: `1px solid ${purple}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${purple}`
  },
  buttonContainerSpaceBetween: {
    width: '30%'
  },
  frequencyButtonContainer: {
    width: '30%'
  },
  // BackButton
  backButton: {
    fontSize: '14px',
    color: purple
  },
  // Box
  boxComponent: {
    borderRadius: '24px',
    border: 'none',
    shadow: '0 8px 24px 0 rgba(51, 37, 97, 0.12)'
  },
  // Button
  button: {
    borderRadius: '28px',
    fontFamily: bodyFont,
    fontSize: '18px',
    fontWeight: '700',
    height: '56px',
    backgroundColor: purple,
    color: '#fff',
    boxShadow: 'none',
    transition: 'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease',
    active: css`
      background-color: ${purpleDark};
      border-color: ${purpleDark};
      color: #fff;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: #fff;
      border-color: ${purple};
      color: ${purple};
    `,
    focus: css`
      box-shadow: 0 0 0 3px ${lilacDark};
    `
  },
  // Checkbox
  inputCheckbox: {
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '4px'
  },
  box: {
    fontSize: '14px',
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`,
    borderHover: `1px solid ${purple}`,
    backgroundColorChecked: purple,
    backgroundBorderChecked: `1px solid ${purple}`
  },
  // Collecting
  collecting: {
    imageTopRight: true,
    height: '60px',
    heightMobile: '60px',
    margin: '30px 16px 20px 0',
    marginMobile: '30px 16px 20px 0'
  },
  // DateInput
  dateDropdown: {
    padding: '10px 30px 12.4px 10px',
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '8px',
    borderFocus: `1px solid ${purple}`,
    boxShadowFocus: `0 0 0 3px ${lilacDark}`,
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    borderValid: `1px solid ${inputBorderColor}`,
    boxShadowValid: 'none'
  },
  // DisplayIban
  iban: {
    fontFamily: bodyFont,
    color: '#fff'
  },
  // Dropdown
  dropdown: {
    height: '46px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    fontSize: '16px',
    paddingLeft: '13px',
    border: `1px solid ${inputBorderColor}`,
    borderFocus: `1px solid ${purple}`,
    boxShadow: 'none',
    boxShadowFocus: `0 0 0 3px ${lilacDark}`,
    boxShadowError: `0 0 0 1px ${errorColor}`,
    boxShadowValid: 'none'
  },
  // ErrorMessage
  error: {
    backgroundColor: '#FBECEC',
    color: errorColor,
    height: '49px'
  },
  // Iban
  ibanContainer: {
    display: 'none'
  },
  // Input
  inputComponent: {
    fontSize: '16px',
    color: darkPurple,
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '8px',
    borderHover: `1px solid ${purple}`,
    boxShadowHover: 'none',
    borderFocus: `1px solid ${purple}`,
    boxShadowFocus: `0 0 0 3px ${lilacDark}`,
    colorPlaceholder: placeholderColor,
    borderValid: `1px solid ${inputBorderColor}`,
    boxShadowValid: 'none',
    backgroundColorValid: '#fff',
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    colorError: errorColor,
    backgroundColorError: '#FFF5F5'
  },
  // TextArea
  textAreaComponent: {
    fontSize: '16px',
    color: darkPurple,
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '8px',
    borderHover: `1px solid ${purple}`,
    boxShadowHover: 'none',
    borderFocus: `1px solid ${purple}`,
    boxShadowFocus: `0 0 0 3px ${lilacDark}`,
    colorPlaceholder: placeholderColor,
    borderValid: `1px solid ${inputBorderColor}`,
    boxShadowValid: 'none',
    backgroundColorValid: '#fff',
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    colorError: errorColor,
    backgroundColorError: '#FFF5F5'
  },
  // Label
  optionalLabel: {
    color: inputBorderColor
  },
  label: {
    fontSize: '14px',
    fontWeight: '700',
    color: darkPurple,
    colorError: errorColor
  },
  logo: {
    width: '168px',
    height: '40px',
    backgroundImage: logoMdl,
    widthMobile: '126px',
    heightMobile: '30px',
    margin: '30px 0 20px 0',
    marginMobile: '30px 0 20px 16px'
  },
  // PaymentButton
  paymentButton: {
    color: darkPurple,
    fontFamily: bodyFont,
    fontSize: '11px',
    width: 'calc(36% - 10px)',
    height: '56px',
    lineHeight: '45px',
    border: `1px solid ${borderColor}`,
    borderRadius: '12px',
    backgroundColor: '#fff',
    backgroundColorActive: lilac,
    borderHover: `1px solid ${purple}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${purple}`
  },
  // ProgressBar
  progressBar: {
    step1: css`
      width: 70px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 70px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 70px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 40px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 40px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  // RadioButton
  inputRadioButton: {
    fontSize: '16px',
    backgroundColor: '#fff',
    border: `1px solid ${inputBorderColor}`,
    backgroundColorDisabled: borderColor,
    backgroundColorActive: purple,
    borderActive: `1px solid ${purple}`,
    borderDisabled: `1px solid ${borderColor}`
  },
  radio: {
    borderHover: `1px solid ${purple}`,
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`
  },
  // TeaserHeader
  teaser: {
    hideOnMobile: true,
    display: 'inline',
    fontFamily: titleFont,
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '46px',
    color: '#fff',
    backgroundColor: purple,
    colorSubtitle: darkPurple,
    backgroundColorSubtitle: '#fff',
    padding: '3px 10px',
    fontSizeTablet: '28px',
    lineHeightTablet: '42px',
    fontSizeWide: '36px',
    lineHeightWide: '50px',
    subtitleFontFamily: bodyFont,
    subtitleFontSize: '18px',
    subtitleLineHeight: '31px',
    subtitleFontSizeWide: '18px',
    subtitleLineHeightWide: '31px',
    subtitleFontSizeTablet: '18px',
    subtitleLineHeightTablet: '31px',
    paddingTop: '0',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'right',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'right'
  },
  teaserContainer: {
    margin: '10px 0 0 0'
  },
  // Title
  title: {
    color: purple,
    fontFamily: titleFont,
    fontSize: '20px',
    height: '64px',
    fontWeight: '700',
    borderRadius: '24px',
    backgroundColor: lilac,
    widthProperty: 'max-width: 280px;'
  },
  // Validation
  validation: {
    color: errorColor,
    fontSize: '14px'
  },
  // OptIn
  optInButton: {
    fontFamily: bodyFont,
    fontSize: '18px',
    borderRadius: '28px',
    backgroundColor: purple,
    color: '#fff',
    boxShadow: 'none',
    active: css`
      background-color: ${purpleDark};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${purpleDark};
    `,
    focus: css`
      box-shadow: 0 0 0 3px ${lilacDark};
    `
  },
  // PersonalMessage
  personalMessage: {
    fontFamily: bodyFont,
    fontSize: '18px',
    buttonFontSize: '18px',
    backgroundColor: lilac,
    color: darkPurple,
    boxShadow: 'none',
    active: css`
      border-bottom: none;
      box-shadow: none !important;
    `,
    focus: css`
      box-shadow: none;
    `,
    checkmarkColor: purple
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: darkPurple,
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  },
  privacyLabel: {
    standard: {
      fontSize: '12px'
    }
  },
  amountText: {
    boldFrequency: true
  }
};
